import { Menu } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@punto-firma/ui/components/button";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@punto-firma/ui/components/sheet";

import { SidebarBrand, SidebarNav } from "./sidebar";
import { UserMenu } from "./user-menu";

/** Cabecera: en móvil, el menú lateral en un `Sheet`; a la derecha, el usuario. */
export const Header = () => {
  const { t } = useTranslation("nav");
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-3 border-b bg-background px-4 md:px-8">
      <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0 md:hidden">
            <Menu className="size-5" aria-hidden />
            <span className="sr-only">{t("openMenu")}</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="flex flex-col gap-6">
          <SheetTitle className="sr-only">{t("ariaLabel")}</SheetTitle>
          <SidebarBrand onNavigate={() => setMenuOpen(false)} />
          <SidebarNav onNavigate={() => setMenuOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="md:hidden">
        <SidebarBrand />
      </div>
      <div className="ml-auto">
        <UserMenu />
      </div>
    </header>
  );
};
